// A scheme-less value is treated as an external host, EXCEPT when it starts with / # or ? —
// those are deliberate same-origin links and must not get '//' prepended (WEB-7233).
const ALREADY_RESOLVABLE = ['https://', 'http://', '//', '/', '#', '?'];

export const formatURL = function (url: string) {
	const trimmed = url ? url.trim() : '';
	if (trimmed) {
		if (ALREADY_RESOLVABLE.some(prefix => trimmed.startsWith(prefix))) {
			return trimmed;
		} else {
			return '//' + trimmed;
		}
	} else {
		return '';
	}
};
